import styled from "styled-components";
import { darken } from "polished";

export const Container = styled.div`
    width: 100%;
    position: relative;
`;

export const Main = styled.main`
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    overflow-x: hidden;
    gap: 200px;
`;

export const PresentationSection = styled.section`
    display: flex;
    justify-content: center;
    height: calc(100vh - 6rem);
    gap: 1rem;
    padding: 1rem;
`;

export const Info = styled.div`
    font-family: ${({ theme }) => theme.fonts.fun};
    font-weight: 600;
    width: 100%;

    padding: 4rem;
    border-radius: 25px;

    display: flex;
    flex-direction: column;

    margin: auto 0;

    @media screen and (max-width: 600px) {
        padding: 1rem;
    }

    ul {
        margin-top: 20px;
        display: flex;
        align-items: center;
        gap: 20px;
    }
`;

export const Greetings = styled.h1`
    font-size: ${({ theme }) => theme.sizes.large};

    @media screen and (max-width: 800px) {
        font-size: 2rem;
    }
`;



export const H1 = styled.h1`
    font-size: ${({ size }) => size ?? "10rem"};
    font-family: ${({ theme, font }) => font ?? theme.fonts.fun };
    position: relative;
    
    &::after {
        content: '';
        width: 100%;
        height: 4px;
        bottom: 0;
        left: 0;
        position: absolute;
        background: linear-gradient(to right, ${({ theme }) => theme.colors.primary}, #fa7f72);
    }

    @media screen and (max-width: 600px) {
        font-size: 2rem;
    }
`;

export const Subtitle = styled.h2`
    font-family: ${({ theme }) => theme.fonts.sub};
    font-weight: ${({ theme }) => theme.fontWeight.light};
`;

export const KnowMeBetterContainer = styled.div`
    background: url(https://images.pexels.com/photos/943096/pexels-photo-943096.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: right;
    border-radius: 25px;
    width: 600px;

    :hover {
        cursor: pointer;
        color: white;
    }

    @media screen and (max-width: 1100px) {
        display: none;
    }
`;

export const MyProjectsSection = styled.section`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 1000px;
    margin: 0 auto;
    padding: 1rem 0;
    flex: 1;
`;

export const PortfolioSummary = styled.p`
    font-size: 1.5rem;
    text-align: center;
    margin-top: 20px;

    @media screen and (max-width: 840px) {
        font-size: 1rem;
    }
`;

export const Carousel = styled.ul`
    display: grid;
    grid-template-columns: 400px 400px;
    gap: 1rem;
    margin-top: 20px;

    @media screen and (max-width: 840px) {
        grid-template-columns: 1fr;
    }
`;

export const CommingSoon = styled.li`
    height: 330px;
    width: 100%;
    border-radius: 25px;
    box-shadow: inset 0 0 8px 8px #adadad28;
    display: flex;
    justify-content: center;
    align-items: center;
    background: linear-gradient(to right bottom, ${({ theme }) => theme.colors.primary}, ${({ theme }) => theme.colors.salmon});
`;

export const MySummary = styled.section`
    display: grid;
    grid-template-areas: 
        "title image"
        "text image";
    position: relative;
    margin: 0 auto;
    gap: 30px;

    width: 1000px;

    > h1 {
        grid-area: title;
    }


    @media screen and (max-width: 1100px) {
        width: 80%;
    }

    @media screen and (max-width: 900px) {
        grid-template-areas: 
            "image"
            "title"
            "text";
    }
`;

export const Text = styled.p`
    grid-area: text;
    font-family: Roboto, sans-serif;
    font-size: ${({ theme }) => theme.sizes.textSize};
    font-weight: ${({ theme }) => theme.fontWeight.light};
    color: #2b2b2b;
    line-height: 2.4rem;
    text-indent: 2rem;
    
    @media screen and (max-width: 1250px) {
        font-size: 1rem;
        line-height: 2rem;
    }
`;

export const Link = styled.a`
    color: blue;
`;

export const ProfilePictureContainer = styled.div`
    grid-area: image;
    width: 315px;
    clip-path: circle();
    background: linear-gradient(to right, ${({ theme }) => theme.colors.primary}, ${({ theme }) => theme.colors.salmon});
    display: flex;
    justify-content: center;
    align-items: center;

    @media screen and (max-width: 1100px) {
        width: 210px;
        height: 210px;
    }
`;

export const ProfilePicture = styled.img`
    width: 300px;
    height: 300px;
    background-repeat: no-repeat;
    background-position: center;
    object-fit: cover;
    clip-path: circle();
    border: 5px solid #d7e7fa;
    border-radius: 50%;

    @media screen and (max-width: 1100px) {
        width: 200px;
        height: 200px;
    }
`;

export const TechnologiesSection = styled.section`
    height: max-content;

    @media screen and (max-width: 950px) {
        flex-direction: column;
    }
`;

export const TechList = styled.ul`
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 70px 45px;
    border-right: 1px solid #e4e4e4;
    
    &:last-child {
        border-right: none;
    }

    @media screen and (max-width: 1100px) {
        padding: 30px;
        border-right: none;
        border-bottom: 1px solid #e4e4e4;
        
        &:last-child {
            border: none;
        }
    }
`;

export const Box = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    width: 70%;
    background-color: white;

    margin: 0 auto;
    transform: translateY(-10rem);
    border-radius: ${({ theme }) => theme.borderRadius};
    border: 1px solid #e4e4e4;

    @media screen and (max-width: 1100px) {
        display: flex;
        flex-direction: column;
    }

    @media screen and (max-width: 600px) {
        width: 90%;
    }
`;

export const Item = styled.li`
    display: flex;
    gap: 10px;
    border-radius: 50px;

    align-items: center;
    font-family: ${({ theme }) => theme.fonts.fun};
    background-color: ${({ color }) => color};

    position: relative;

    left: ${({ left }) => left};

    padding: 5px 10px;

    transition: all 200ms;

    background-color: white;

    &:hover {
        cursor: pointer;
        box-shadow: 0px 0px 10px 5px #d8d8d89d;
        transform: scale(1.05);
    }
`;

export const Contact = styled.section`
    display: flex;
    flex-direction: column;
    position: relative;
    
    height: 500px;

    background-color: ${({ theme }) => theme.colors.primary};

    box-shadow: 0px 0px 10px 5px #f3f3f3;


    > ul {
        display: flex;
        gap: 5px;
        background-color: #505050;
        place-content: center;
        padding: 10px;
        width: 100%;
    }

    @media screen and (max-width: 900px) {
        height: auto;
    }
`;

export const ContactContent = styled.div`
    flex: 1;
    display: grid;
    grid-template-columns: 1fr 1fr;
    padding: 5rem;
    
    @media screen and (max-width: 900px) {
        display: flex;
        flex-direction: column;
        gap: 30px;
    }
`;

export const FooterInfo = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 2rem;
    position: relative;

    &::after {
        content: '';
        height: 300px;
        width: 1px;
        position: absolute;
        background-color: #505050;
        right: 0;

        @media screen and (max-width: 900px) {
            display: none;
        }
    }

    p {
        max-width: 500px;
    }

    > h2 {
        @media screen and (max-width: 500px) {
            font-size: 3rem;
        }
    }

`;

export const FooterMyContact = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;

    ul {
        display: flex;
        flex-direction: column;
        gap: 15px;

        li {
            display: flex;
            align-items: center;
            gap: 5px;
        }
    }
`;

export const FooterTitle = styled.h2`
    font-size: ${({ size }) => `${size}rem`};
    color: white;

    background: linear-gradient(to right, ${({ theme }) => darken(.12, theme.colors.primary)}, ${({ theme }) => darken(.1, theme.colors.salmon)});

    padding: ${({ size, fontSize }) => `.3125rem`} ${({ size, fontSize }) => `.625rem`};

    border-radius: ${({ theme }) => `calc(${theme.borderRadius} * 4)`};

    width: max-content;
`;

export const GithubButton = styled.button`
    border-radius: 25px;
    padding: 5px 15px;
    border: none;
    font-size: 1.4rem;
    display: flex;
    align-items: center;
    background-color: #0d1117;
    color: white;
    transition: all 150ms;

    margin-top: 30px;

    &:hover {
        box-shadow: 0px 0px 3px 4px #0d111733;
    }

    a {
        display: flex;
        flex-direction: row;
        color: white;
        align-items: center;
        gap: 10px;
    }
`;

export const WhoIAmSection = styled.section`
    display: flex;

    padding-top: 10rem;
    padding-bottom: 18rem;
    flex-direction: column;
    background-color: #d7e7fa;
`;

export const TimelineSection = styled.div`
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;
    position: relative;
`;

export const CareerVision = styled.section`
    height: 100vh;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 50px;

    @media screen and (max-width: 1450px) {
        flex-direction: column-reverse;
        height: max-content;
    }
`;

export const Content = styled.div`
    max-width: 800px;
    padding: 1rem 2rem;
    border-radius: ${({ theme }) => theme.borderRadius};

    b {
        color: ${({ theme }) => theme.colors.salmon};
        position: relative;

        &::after {
            content: '';
            position: absolute;
            width: 100%;
            height: 2px;
            left: 0;
            bottom: 0;
            background-color: ${({ theme }) => theme.colors.salmon};
        }
    }
`;

export const Image = styled.img`
    width: ${({ size }) => size || "900px"};
    min-width: 700px;
    max-width: 100%;
    border-radius: ${({ theme }) => theme.borderRadius};

    @media screen and (max-width: 1250px) {
        border-radius: 15px;
        min-width: auto;
    }
`;

export const MySkillsImage = styled.div`
    position: relative;
    margin: 0 10px;

    &::before {
        content: '';
        width: 100%;
        height: 100%;
        border-radius: ${({ theme }) => theme.borderRadius};
        background-color: ${({ theme }) => theme.colors.primary};
        position: absolute;
        z-index: -1;
        transform: translate(-30px, -30px);
    }
`;

export const CareerImageContainer = styled.div`
    position: relative;

    &::before {
        content: '';
        width: 100%;
        height: 100%;
        border-radius: ${({ theme }) => theme.borderRadius};
        background-color: ${({ theme }) => theme.colors.primary};
        position: absolute;
        z-index: -1;
        transform: translate(30px, 30px);

        @media screen and (max-width: 1250px) {
            transform: translate(10px, 10px);
        }
    }

    @media screen and (max-width: 1250px) {
        margin: 10px;
    }
`;
